<template>
  <span :class="badgeClasses" data-testid="content-type-badge">
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CONTENT_TYPE_LABELS, type ContentType } from '../../constants';

interface Props {
  contentType: ContentType;
  collectLogs?: boolean;
}

const props = defineProps<Props>();

const label = computed(() => {
  if (props.contentType === 'video' && props.collectLogs) {
    return 'Video+Logs';
  }

  return CONTENT_TYPE_LABELS[props.contentType] || 'Video';
});

const badgeClasses = computed(() => {
  const base = 'content-type-badge';
  switch (props.contentType) {
    case 'file':
      return [base, 'content-type-badge-file'];
    case 'image':
      return [base, 'content-type-badge-image'];
    default:
      return [base, 'content-type-badge-video'];
  }
});
</script>

<style scoped>
.content-type-badge {
  @apply inline-flex items-center px-1.5 py-0.5 rounded-full text-sm font-medium;
}

.content-type-badge-video {
  @apply bg-zinc-100 text-zinc-600 dark:bg-zinc-700 dark:text-zinc-300;
}

.content-type-badge-file {
  @apply bg-blue-100 text-blue-800 dark:bg-zinc-700 dark:text-blue-300;
}

.content-type-badge-image {
  @apply bg-green-100 text-green-800 dark:bg-zinc-700 dark:text-green-300;
}
</style>
